import React, { useEffect, useState } from 'react';
// import Grid from '@mui/material/Grid';
import {
    useSensors,
    useSensor,
    PointerSensor,
    KeyboardSensor,
    DndContext,
    closestCorners,
    DragOverlay,
    defaultDropAnimation,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates, arrayMove } from '@dnd-kit/sortable';
import AppSection from './AppSection';
import AppItem from './AppItem';
import FlexComponent from '../../FlexComponent';
import { Button } from 'primereact/button';
import Swal from 'sweetalert2';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import AppModal from '../../../shared/AppModal';
import { Avatar } from 'primereact/avatar';
import { Calendar } from 'primereact/calendar';
import { upserCustomFieldValue } from '../../../utils/urls';
import axios from '../../../utils/axios';

const findBoardSectionContainer = (boardSections, id) => {
    if (id in boardSections) {
        return id;
    }

    const container = Object.keys(boardSections).find((key) =>
        boardSections[key].find((item) => item.form_id === id)
    );
    return container;
};

const AppSectionList = ({ userId, toast, boardSections, pipeline, allPipelinesData, softwareUsers, usersList, selectedUsers, selectedApplicationByUsers, language, labels, dateRange, dueDateRange, lastCommunicationRange, lastCommunicationFilter, companies, incomeRangeValue, creditRangeValue, savingsRangeValue, appScoreValue, stageAppCounts, stageIds, stageWatchers, setTotal, setStageAppCounts, setBoardSections, handleStageUpdate, searchQuery, sortBy, isActive, isMounted, setIsMounted, loading, stageLoading, isSelectMode, selectedCards, onCardSelect }) => {
    const [activeAppId, setActiveAppId] = useState(null);
    const [visible, setVisible] = useState(false)
    const [closingDateVisible, setClosingDateVisible] = useState(false)
    const [wantEmail, setWantEmail] = useState(null)
    const [emails, setEmails] = useState([])
    const [emailInput, setEmailInput] = useState('')
    const [closingDate, setClosingDate] = useState([])
    const [appDetails, setAppDetails] = useState()
    const getAppById = (apps, id) => {
        for (const itemId in apps) {
            const items = apps[itemId];
            for (const item of items) {
                if (item.id === id) {
                    return item;
                }
            }
        }
    };

    const app = activeAppId ? getAppById(boardSections, activeAppId) : null;
    const [customFieldUpdateAppId, setCustomFieldUpdateAppId] = useState(null)

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            Add CC Emails
        </div>
    );

    const resetEmailDialog = () => {
        setVisible(false);
        setWantEmail(null);
        setEmails([]);
        setEmailInput('');
    };

    const footerContent = (
        <div>
            {wantEmail === null ? (
                <>
                    <Button label="No" style={{ background: "red" }} onClick={() => {
                        resetEmailDialog();
                        handleStageUpdate(appDetails.ghl_contact_id, appDetails.form_id, appDetails.overContainer, appDetails.app_status, []);
                    }} autoFocus />
                    <Button label="Yes" icon="pi pi-check" onClick={() => setWantEmail(true)} autoFocus />
                </>
            ) : (
                <>
                    <Button label="Cancel" style={{ background: "red" }} onClick={() => {
                        resetEmailDialog();
                        setIsMounted(!isMounted);
                    }} autoFocus />
                    <Button label="Continue" icon="pi pi-check" onClick={() => {
                        const pending = emailInput.trim();
                        const finalEmails = pending && !emails.includes(pending) ? [...emails, pending] : emails;
                        resetEmailDialog();
                        handleStageUpdate(appDetails.ghl_contact_id, appDetails.form_id, appDetails.overContainer, appDetails.app_status, finalEmails);
                    }} autoFocus />
                </>
            )}
        </div>
    );

    const closingDateHeaderElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            Add Closing Date
        </div>
    );

    const closingDateFooterContent = (
        <div>
            <Button label="Cancel" style={{ background: "red" }} onClick={() => {
                setClosingDateVisible(false)
                setIsMounted(!isMounted)
                // handleStageUpdate(app.ghl_contact_id, app.form_id, overContainer, app.app_status)
            }} autoFocus />
            <Button label="Continue" icon="pi pi-check" onClick={() => {
                setClosingDateVisible(false)
                updateCustomField()
                handleStageUpdate(appDetails.ghl_contact_id, appDetails.form_id, appDetails.overContainer, appDetails.app_status)
            }} autoFocus />
        </div>
    );

    const convertDateToString = (date) => {
        if (!date) return '';
        const year = date?.getFullYear();
        const month = String(date.getMonth() + 1)?.padStart(2, '0'); // month is 0-based in Date
        const day = String(date.getDate())?.padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // console.log("app", app);
    // console.log("customFieldUpdateAppId", customFieldUpdateAppId);

    const updateCustomField = () => {
        // setLoading(true)
        console.log("app", app);

        const data = {
            form_id: customFieldUpdateAppId,
            custom_field_id: 38,
            value: convertDateToString(closingDate)
        }
        // console.log(data)
        axios.post(upserCustomFieldValue, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    // toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                }
            })
            .catch((error) => {
                // toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                // setLoading(false)
            })
    }

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: { distance: 1 }
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const handleDragStart = ({ active }) => {
        setActiveAppId(active.id);
    };
    // console.log(boardSections)



    const handleDragOver = ({ active, over }) => {
        const activeContainer = findBoardSectionContainer(boardSections, active.id);
        const overContainer = findBoardSectionContainer(boardSections, over?.id);

        if (!activeContainer || !overContainer || activeContainer === overContainer) {
            return;
        }

        // console.log('handleDragOver','||' ,'activeContainer: ', activeContainer , 'overContainer: ',overContainer)

        setBoardSections((boardSection) => {
            // console.log(boardSection)
            const activeItems = boardSection[activeContainer];
            const overItems = boardSection[overContainer];
            const activeIndex = activeItems.findIndex((item) => item.id === active.id);
            const overIndex = overItems.findIndex((item) => item.id !== over?.id);
            // console.log('handleDragOver ||', 'activeIndex: ', activeIndex, 'overIndex: ', overIndex )
            return {
                ...boardSection,
                [activeContainer]: [
                    ...boardSection[activeContainer].filter((item) => item.id !== active.id),
                ],
                [overContainer]: [
                    ...boardSection[overContainer].slice(0, overIndex),
                    boardSections[activeContainer][activeIndex],
                    ...boardSection[overContainer].slice(overIndex, boardSection[overContainer].length),
                ],
            };
        });
    };

    const handleDragEnd = ({ active, over }) => {
        // console.log('handleDragEnd','||' ,'active: ', active , 'over: ',over)
        const activeContainer = findBoardSectionContainer(boardSections, active.id);
        const overContainer = findBoardSectionContainer(boardSections, over?.id);

        if (!activeContainer || !overContainer || activeContainer !== overContainer) {
            return;
        }

        // console.log('handleDragEnd','||' ,'activeContainer: ', activeContainer , 'overContainer: ',overContainer)

        const activeIndex = boardSections[activeContainer].findIndex((app) => app.id === active.id);
        const overIndex = boardSections[overContainer].findIndex((app) => app.id === over?.id);
        if (activeIndex !== overIndex) {
            setBoardSections((boardSection) => ({
                ...boardSection,
                [overContainer]: arrayMove(boardSection[overContainer], activeIndex, overIndex),
            }));
        }
        // console.log(app)

        if (app.app_status != overContainer) {
            // console.log("app.app_status", app.app_status)
            // console.log("overContainer122", overContainer)
            if (overContainer === "🤖 Auto Doc Request") {
                // Swal.fire({
                //     title: "Are you sure you want to update the app to 'Auto Doc Request'?",
                //     icon: 'warning',
                //     showCancelButton: true,
                //     confirmButtonColor: '#3085d6',
                //     cancelButtonColor: '#d33',
                //     confirmButtonText: 'Yes',
                //     }).then((result) => {
                //         if (result.isConfirmed) {
                //             handleStageUpdate(app.ghl_contact_id, app.form_id, overContainer, app.app_status)
                //         }else{
                //             setIsMounted(!isMounted)
                //         }
                //     })
                setAppDetails({ ...app, overContainer });
                setWantEmail(null);
                setVisible(true)

            } else if (overContainer === "Closed 💰") {
                setCustomFieldUpdateAppId(app.form_id)
                setAppDetails({ ...app, overContainer });
                setClosingDateVisible(true)
            } else {
                handleStageUpdate(app.ghl_contact_id, app.form_id, overContainer, app.app_status)
            }
        }

        const updateStatusInSection = (section, itemId, newStatus) => {
            setBoardSections((prevBoardSections) => {
                if (section in prevBoardSections) {
                    const sectionIndex = prevBoardSections[section]?.findIndex((item) => item?.id === itemId);
                    if (sectionIndex !== -1) {
                        const updatedSection = [...prevBoardSections[section]];
                        updatedSection[sectionIndex].app_status = newStatus;
                        return {
                            ...prevBoardSections,
                            [section]: updatedSection,
                        };
                    }
                }
                return prevBoardSections;
            });
        };
        updateStatusInSection(overContainer, app.id, overContainer)
        setActiveAppId(null);
    };

    //   const dropAnimation = defaultDropAnimation;


    return (
        <div >
            {/* <ConfirmDialog /> */}
            <AppModal visible={visible} header={headerElement} footer={footerContent} panelStyle={{ width: '50rem' }} onHide={() => {
                if (!visible) return;
                resetEmailDialog();
                setIsMounted(!isMounted);
            }}>
                {wantEmail === null ? (
                    <div style={{ textAlign: 'center', padding: '1rem 0' }}>
                        <p style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>Do you want to send an email?</p>
                        <p style={{ fontSize: '0.85rem', color: '#888', margin: 0 }}>Select Yes to add CC email addresses, or No to continue without sending.</p>
                    </div>
                ) : (
                    <div className="p-fluid">
                        <div style={{ marginBottom: '0.5rem' }}>Emails</div>
                        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.75rem' }}>
                            <input
                                type="email"
                                className="p-inputtext p-component"
                                style={{ flex: 1 }}
                                value={emailInput}
                                placeholder="Enter email address"
                                onChange={(e) => setEmailInput(e.target.value)}
                                onBlur={() => {
                                    const val = emailInput.trim();
                                    if (val && !emails.includes(val)) {
                                        setEmails((prev) => [...prev, val]);
                                        setEmailInput('');
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        const val = emailInput.trim();
                                        if (val && !emails.includes(val)) {
                                            setEmails((prev) => [...prev, val]);
                                            setEmailInput('');
                                        }
                                    }
                                }}
                            />
                            <Button
                                type="button"
                                label="Add"
                                icon="pi pi-plus"
                                style={{ width: 'auto' }}
                                onClick={() => {
                                    const val = emailInput.trim();
                                    if (val && !emails.includes(val)) {
                                        setEmails((prev) => [...prev, val]);
                                        setEmailInput('');
                                    }
                                }}
                            />
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                            {emails.map((email, i) => (
                                <span key={i} style={{ display: 'inline-flex', alignItems: 'center', background: 'black', color: 'white', borderRadius: '1rem', padding: '0.25rem 0.75rem', fontSize: '0.875rem', gap: '0.4rem' }}>
                                    {email}
                                    <i className="pi pi-times" style={{ cursor: 'pointer', fontSize: '0.75rem' }} onClick={() => setEmails((prev) => prev.filter((_, idx) => idx !== i))} />
                                </span>
                            ))}
                        </div>
                    </div>
                )}
            </AppModal>
            <AppModal visible={closingDateVisible} header={closingDateHeaderElement} footer={closingDateFooterContent} panelStyle={{ width: '30rem' }} onHide={() => {
                if (!closingDateVisible) return; setClosingDateVisible(false);
                setIsMounted(!isMounted)
            }}>
                <div>Closing Date</div>
                <Calendar
                    style={{
                        width: '100%',
                        // background: isFocused ? "white" : "#20385E"
                    }}
                    value={closingDate}
                    onChange={(e) => {
                        setClosingDate(e.value)
                    }} />
            </AppModal>
            <DndContext
                sensors={sensors}
                collisionDetection={closestCorners}
                onDragStart={handleDragStart}
                onDragOver={handleDragOver}
                onDragEnd={handleDragEnd}
            >
                <FlexComponent gap='2rem' style={{ color: 'black', width: '100%', padding: '0 15px 15px 15px' }} className='applicantCardInnerDiv' alignItems='start' container spacing={4}>
                    {Object?.keys(boardSections)?.map((boardSectionKey) => (
                        <FlexComponent item key={boardSectionKey} >
                            <AppSection
                                id={boardSectionKey}
                                userId={userId}
                                handleStageUpdate={handleStageUpdate}
                                setIsMounted={setIsMounted}
                                isMounted={isMounted}
                                pipeline={pipeline}
                                allPipelinesData={allPipelinesData}
                                stageAppCounts={stageAppCounts}
                                setTotal={setTotal}
                                stageIds={stageIds}
                                stageWatchers={stageWatchers}
                                selectedUsers={selectedUsers}
                                selectedApplicationByUsers={selectedApplicationByUsers}
                                apps={boardSections[boardSectionKey]}
                                setBoardSections={setBoardSections}
                                searchQuery={searchQuery}
                                sortBy={sortBy}
                                isActive={isActive}
                                usersList={usersList}
                                softwareUsers={softwareUsers}
                                language={language}
                                incomeRangeValue={incomeRangeValue}
                                creditRangeValue={creditRangeValue}
                                savingsRangeValue={savingsRangeValue}
                                appScoreValue={appScoreValue}
                                labels={labels}
                                dateRange={dateRange}
                                dueDateRange={dueDateRange}
                                lastCommunicationRange={lastCommunicationRange}
                                lastCommunicationFilter={lastCommunicationFilter}
                                companies={companies}
                                loading={loading}
                                stageLoading={stageLoading}
                                toast={toast}
                                isSelectMode={isSelectMode}
                                selectedCards={selectedCards}
                                onCardSelect={onCardSelect}
                            />
                        </FlexComponent>
                    ))}
                    <DragOverlay dropAnimation={defaultDropAnimation}>
                        <AppItem app={app} setBoardSections={setBoardSections} toast={toast} />
                    </DragOverlay>
                </FlexComponent>
            </DndContext>
        </div>
    );
};

export default AppSectionList;
